import { useMediaQuery } from "../../../hooks/useMediaQuery";
import type { ToastWithTimer } from "../../../types/toast";
import { MemoizedToast } from "./toast";
import styles from "./toastPanel.module.css";

const MAX_VISIBLE_TOASTS = 3;

export interface ToastPanelProps {
  toasts: ToastWithTimer[];
  onRemove: (id: string) => void;
  onPause: (id: string) => void;
  onResume: (id: string) => void;
  onAppearComplete: (id: string) => void;
}

export function ToastPanel({
  toasts,
  onRemove,
  onPause,
  onResume,
  onAppearComplete,
}: ToastPanelProps) {
  const isWide = useMediaQuery("(min-width: 25rem)");

  const visibleToasts = toasts.slice(0, MAX_VISIBLE_TOASTS);

  if (visibleToasts.length === 0) {
    return null;
  }

  const containerClass = isWide ? styles.containerWide : styles.containerNarrow;

  return (
    <div className={`${styles.container} ${containerClass}`}>
      {visibleToasts.map((toast) => (
        <MemoizedToast
          key={toast.id}
          toast={toast}
          onRemove={onRemove}
          onPause={onPause}
          onResume={onResume}
          onAppearComplete={onAppearComplete}
        />
      ))}
    </div>
  );
}
